import { createBrowserRouter, Navigate } from "react-router-dom";
import BankTransactionsList from "./views/BankTransactionsList/BankTransactionsList";
import Stats from "./views/Stats/Stats";
import App from "./App";
import BudgetsList from "./views/Budgets/BudgetsList";
import Login from "./views/Login/Login";
import BankConnections from "./views/BankConnections/BankConnections";

const Router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                index: true,
                element: <Navigate to="/stats" replace={true} />
            },
            {
                path: "/budgets",
                element: <BudgetsList/>,
            },
            {
                path: "/accounts/:accountId/:filename",
                element: <BankTransactionsList/>,
            },
            {
                path: "/accounts/:accountId",
                element: <BankTransactionsList/>,
            },
            {
                path: "/accounts",
                element: <BankTransactionsList/>,
            },
            {
                // Anciennes URLs, avant les comptes
                path: "/bank_transactions/*",
                element: <Navigate to="/accounts" replace={true} />
            },
            {
                path: "/stats",
                element: <Stats/>,
            },
            {
                path: "/bank_connections",
                element: <BankConnections/>,
            }
        ]
    },
    {
        path: "/login",
        element: <Login/>,
    }
    
]);

export default Router